export enum EContactType {
  corporate = 'Corporate',
  individual = 'Individual',
}
